
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { PayrollSummary } from '@/types';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';
import { formatCurrency } from '@/lib/utils';

interface PayrollChartProps {
  data: PayrollSummary[];
}

export const PayrollChart = ({ data }: PayrollChartProps) => {
  const formattedData = data.map(item => ({
    name: item.period,
    Gross: item.totalGrossSalary,
    Net: item.totalNetSalary,
    Deductions: item.totalDeductions
  }));

  // Custom tooltip formatter to display values with ZMW currency
  const tooltipFormatter = (value: number | string) => {
    if (typeof value === 'number') {
      return formatCurrency(value);
    }
    return value;
  };

  return (
    <Card className="col-span-2">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg font-medium">Payroll Summary</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={formattedData}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis tickFormatter={(value) => `ZMW ${(value / 1000).toFixed(0)}k`} />
            <Tooltip formatter={tooltipFormatter} />
            <Legend />
            <Bar dataKey="Gross" fill="#3b82f6" />
            <Bar dataKey="Net" fill="#22c55e" />
            <Bar dataKey="Deductions" fill="#f59e0b" />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
